module.exports = __webpack_public_path__ + "static/media/IELTS-GeneralTrainingReading-ChoiceAccordion.599cb692.png";